
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CompanyAccountingSettingModel extends Model<CompanyAccountingSettingModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'companyAccountingSetting.property.companyId' },
		{ name: 'customerNo', type: 'string', languageString: 'companyAccountingSetting.property.customerNo' },
		{ name: 'noHandlingFees', type: 'boolean', languageString: 'companyAccountingSetting.property.noHandlingFees' },
		{ name: 'brandId', type: 'guid', languageString: 'companyAccountingSetting.property.brandId' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public customerNo: string;
	public noHandlingFees: boolean;
	public brandId?: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.customerNo = '';
		this.noHandlingFees = false;
		this.brandId = undefined;
		
	}
	getProperties(){
		return CompanyAccountingSettingModel.classProperties;
	}
}

